module.exports = __webpack_public_path__ + "static/media/video-placeholder.a2d13ba8.svg";